import React, { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import text from "../constants/text.json";
import { imageObject } from "../constants/image";
import color from "../constants/colors.json";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "../App.css";
import styles from "./WebsiteLayout.module.css";

const DOCUMENT_PATHS = [
  "/privacy-policy",
  "/eula",
  "/terms-and-conditions",
];

export default function WebsiteLayout() {
  const isRtl = true;
  const [content, setContent] = useState({});
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = "ar";
    document.documentElement.dir = "rtl";
    document.body.dir = "rtl";
  }, []);

  useEffect(() => {
    async function getWebsiteContent() {
      try {
        const querySnapshot = await getDocs(collection(db, "admin"));
        if (!querySnapshot.empty) {
          const docSnapshot = querySnapshot.docs[0];
          setContent({ id: docSnapshot.id, ...docSnapshot.data() });
        }
      } catch (e) {
        console.log("Error: ", e);
      }
    }
    getWebsiteContent();
  }, []);

  /** Home → Privacy → EULA → Terms */
  const navbarNavItems = useMemo(
    () => [
      { to: "/", end: true, label: text.ArabicHome },
      { to: "/privacy-policy", label: text.Arabic11 },
      { to: "/eula", label: text.Arabic14 },
      { to: "/terms-and-conditions", label: text.Arabic15 },
    ],
    []
  );

  const outletContext = useMemo(
    () => ({
      content,
      isRtl,
      text,
      imageObject,
      color,
    }),
    [content, isRtl]
  );

  const footerProps = {
    reserved: text.Arabic12,
    image: imageObject.image7,
  };

  const isDocumentView = DOCUMENT_PATHS.includes(location.pathname);

  return (
    <div className="App rtl">
      <link rel="stylesheet" href="./css/bootstrap.css" />
      <link rel="stylesheet" href="./fonts/icon-font/css/style.css" />
      <link rel="stylesheet" href="./fonts/typography-font/typo.css" />
      <link rel="stylesheet" href="./fonts/fontawesome-5/css/all.css" />
      <link
        href="https://fonts.googleapis.com/css2?family=Karla:wght@300;400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap"
        rel="stylesheet"
      />

      <div className={styles.shell}>
        <Navbar
          color={color}
          imageObject={imageObject}
          navItems={navbarNavItems}
        />
        <div className={styles.main} dir={isRtl ? "rtl" : "ltr"}>
          <div
            className={`${styles.mainInner} ${
              isDocumentView ? styles.mainInnerDocument : ""
            }`}
          >
            <Outlet context={outletContext} />
          </div>
          <div className={styles.footerWrap}>
            <Footer {...footerProps} />
          </div>
        </div>
      </div>
    </div>
  );
}
